type SectionProps = {
  children?: React.ReactNode
  title: string
  id: string
}

const Section = ({ children, title, id }: SectionProps) => (
  <div className="mb-6">
    <div id={`${id}`}>
      <SectionTitle>{title}</SectionTitle>
      {children}
    </div>
  </div>
)

type SectionTitleProps = {
  children?: React.ReactNode
}
export const SectionTitle = ({ children }: SectionTitleProps) => (
  <h2 className="flex text-2xl text-grey font-600 mb-1">
    <span className="whitespace-normal md:whitespace-no-wrap text-orange">
      {children}
    </span>
    <div className="flex-grow border-2 border-orange-200 bg-orange-200 h-0 ml-1 self-center" />
  </h2>
)

export default Section
